import React from 'react';
import {
    InfoSolidIcon,
    ExclamationSolidIcon,
    CheckSolidIcon,
    CloseSolidIcon,
    type SystemIconType,
} from '@fiverr-private/icons';
import { theme, type Types } from '@fiverr-private/theme';
import type { Variant } from './types';

export const VARIANT = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
    SUCCESS: 'success',
} as const;

export const VARIANTS_CONFIG: {
    [key in Variant]: {
        Icon: React.FC<SystemIconType>;
        iconColor: SystemIconType['color'];
        color: Types.ContainerProps['color'];
        backgroundColor: Types.ContainerProps['backgroundColor'];
    };
} = {
    info: {
        Icon: InfoSolidIcon,
        iconColor: theme.colors.blue_1100,
        color: 'blue_1100',
        backgroundColor: 'blue_100',
    },
    warning: {
        Icon: ExclamationSolidIcon,
        iconColor: theme.colors.orange_1100,
        color: 'orange_1100',
        backgroundColor: 'orange_100',
    },
    success: {
        Icon: CheckSolidIcon,
        iconColor: theme.colors.green_1100,
        color: 'green_1100',
        backgroundColor: 'green_100',
    },
    error: {
        Icon: CloseSolidIcon,
        iconColor: theme.colors.red_1100,
        color: 'red_1100',
        backgroundColor: 'red_100',
    },
};

export const ALERT_TITLE_ID = 'AlertTitle';
export const ALERT_TEXT_ID = 'AlertText';
export const ALERT_ACTIONS_ID = 'AlertActions';
